import React from 'react';
import './count-down.css';

class CountDown extends React.Component {

    constructor(props) {
        super(props);
        this.remainingTimeFunction = this.props.remainingTimeFunction;
        this.showCountDownUnder = this.props.showCountDownUnder;
        this.onReachNoRemainingTime = this.props.onReachNoRemainingTime;
        if (typeof this.remainingTimeFunction === 'function') {
            this.state = {
                remainingTime: this.remainingTimeFunction(),
                initialRemainingTime: this.props.initialRemainingTime
            }
        }
        this.refreshInterval = setInterval(this.updateRemainingTime, 1000);
    }

    render = () => {
        if (typeof this.remainingTimeFunction === 'function') {
            return (
                (this.state.remainingTime <= this.showCountDownUnder &&
                this.getRemainingTimeAsText(this.state.remainingTime)) ||
                this.getRemainingTimeAsText(this.state.initialRemainingTime)
            )
        }
    }

    getRemainingTimeAsText = (time) => {
        return (
            <div>
                <div className="rea-countDownNum">{Math.floor(time / 60000)}</div>
                <div className="rea-countDownNumText"> minutes</div>
                <div className="rea-countDownNum">{Math.floor(time % 60000 / 1000)}</div>
                <div className="rea-countDownNumText"> seconds</div>
            </div>
        );
    }

    updateRemainingTime = () => {
        if (this.state.remainingTime >= 1000) {
            this.setState({remainingTime: this.state.remainingTime - 1000});
        } else {
            clearInterval(this.refreshInterval);
            if (typeof this.onReachNoRemainingTime === 'function') {
                this.onReachNoRemainingTime();
            }
        }


    }
}

export default CountDown;
